import { Input } from "antd";
import Button from "components/common/Button";
import CustomLabel from "components/common/CustomLabel";
import UploadFile from "components/common/UploadFile";
import useStore from "zustand/store";

const CustomerService: React.FC<{ toggle: () => void }> = ({ toggle }) => {
    const { user } = useStore()

    return (<>
        <div className="space-y-5">
            {(!user || !user?.email)
                && <div>
                    <CustomLabel>Email / Mobile Number</CustomLabel>
                    <Input size="large" className="w-full" />
                </div>}

            <div>
                <CustomLabel>What issue would you like us to help you resolve?</CustomLabel>
                <Input.TextArea rows={4}></Input.TextArea>
            </div>

            <div>
                <CustomLabel>Attach</CustomLabel>
                <UploadFile />
            </div>

            <div className="flex justify-end space-x-3 !mt-10">
                <Button onClick={() => toggle()} buttonType="cancel" size="md">Cancel</Button>
                <Button
                    buttonType="primary" size="md">Send Question</Button>
            </div>
        </div>
    </>);
}

export default CustomerService;